import type { TableColumnPref } from "@onengine/component-library";

export const ACTIONS_COLUMN_ID = "more";

/**
 * A saved column order can place the row-actions column anywhere, and columns the order has
 * never seen are appended after it. Rebuilds the order so the actions column is always last.
 */
export function pinActionsLast(
  saved: TableColumnPref[] | undefined,
  columnIds: string[],
): TableColumnPref[] | undefined {
  if (!saved) return saved;
  const known = new Set(saved.map((pref) => pref.id));
  const unseen = columnIds
    .filter((id) => !known.has(id))
    .map((id): TableColumnPref => ({ id, visible: true }));
  const actions =
    saved.find((pref) => pref.id === ACTIONS_COLUMN_ID) ??
    (columnIds.includes(ACTIONS_COLUMN_ID) ? { id: ACTIONS_COLUMN_ID, visible: true } : undefined);
  return [
    ...saved.filter((pref) => pref.id !== ACTIONS_COLUMN_ID),
    ...unseen.filter((pref) => pref.id !== ACTIONS_COLUMN_ID),
    ...(actions ? [actions] : []),
  ];
}
